import { Datatable, Feature, Step } from "../types/Feature";

const parseFileToString = (
  file: File | null,
  callback: (fileContent: string) => void
): void => {
  let fileContent = "";

  if (file) {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      fileContent = fileReader.result as string;
      callback(fileContent);
    };
    fileReader.readAsText(file);
  } else {
    console.error("File not found");
    callback(fileContent);
  }
};

export function convertJSONToGherkin(jsonData: Feature) {
  let featureFile = `Feature: ${jsonData.name}\n\n`;

  // Background
  featureFile += `  Background: ${jsonData.background.name ?? ""}\n`;
  jsonData.background.steps.forEach((step) => {
    const listText: string[] = convertStepsToStrings([step]);
    const text: string = listText[0];
    let featureFileLine: string = `    ${step.keyword} ${text}\n`;
    if (step.datatable !== undefined && step.datatable !== null) {
      featureFileLine += datatableToString(step.datatable) + "\n";
    }
    featureFile += featureFileLine;
  });

  // Scenarios
  jsonData.scenarios.forEach((scenario) => {
    featureFile += `\n  ${tagsToString(scenario.tags)}\n`;
    featureFile += `  Scenario: ${scenario.name}\n`;
    scenario.steps.forEach((step) => {
      const listText: string[] = convertStepsToStrings([step]);
      const text: string = listText[0];
      let featureFileLine: string = `    ${step.keyword} ${text}\n`;
      if (step.datatable !== undefined && step.datatable !== null) {
        featureFileLine += datatableToString(step.datatable) + "\n";
      }
      featureFile += featureFileLine;
    });
  });

  return featureFile;
}

const convertStepsToStrings = (allSteps: Step[]): string[] => {
  return allSteps.map((step) => {
    let actualStep: string = step.text;
    let list: string[] = actualStep.split(" ");
    let count: number = 0;

    for (let i = 0; i < list.length; i++) {
      if (list[i] === "{word}") {
        list[i] = step.values[count];
        count++;
      } else if (list[i] === "{string}") {
        list[i] = `"${step.values[count]}"`;
        count++;
      } else if (list[i] === "{int}") {
        list[i] = step.values[count];
        count++;
      }
    }
    actualStep = list.join(" ");
    return actualStep;
  });
};

export const tagsToString = (tags: string[]) => {
  let updatedTags = ``;
  tags.forEach((tag) => {
    updatedTags += ` ${tag}`;
  });
  return updatedTags.trim();
};

export const datatableToString = (datatable: Datatable) => {
  let headers = "|";
  let rows = "";
  datatable.headers.forEach((header) => {
    headers += ` ${header} |`;
  });
  datatable.rows.forEach((row) => {
    let currentRow = "|";
    row.forEach((rowVal) => {
      currentRow += ` ${rowVal} |`;
    });
    rows += `\n      ${currentRow}`;
  });
  return `      ${headers}${rows}`;
};

export const saveFile = (fileData: string, fileName: string) => {
  const blob = new Blob([fileData], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = fileName + ".feature";
  link.href = url;
  link.click();
};

export default parseFileToString;
